import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CustomMutationOptions, CustomQueryOptions } from '../common.types';
import { WidgetsService } from '../../generated';

const WIDGET_ACTIVATED_QUERY_KEY = ['widget', 'activated'];
const WIDGET_TOKEN_QUERY_KEY = ['widget', 'token'];

export const useWidgetActivated = (
    options: CustomQueryOptions<{ activated: boolean }> = {}
) => {
    return useQuery({
        queryKey: WIDGET_ACTIVATED_QUERY_KEY,
        queryFn: async () => {
            const response = await WidgetsService.getWidgets();

            if (!response.data) throw new Error('Failed');

            return { activated: !!response.data.items?.length };
        },
        ...options,
    });
};

export const useWidgetToken = (
    options: CustomQueryOptions<{ token: string }> = {}
) => {
    return useQuery({
        queryKey: WIDGET_TOKEN_QUERY_KEY,
        queryFn: async () => {
            const response = await WidgetsService.getWidgetToken({
                query: {
                    name: 'generic',
                },
            });

            if (!response.data) throw new Error('Failed');

            // @ts-ignore
            return { token: response.data.access_token };
        },
        ...options,
    });
};

export const useWidgetStatus = (
    options: CustomMutationOptions<{ activate: boolean }, any> = {}
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ activate }) => {
            const response = await WidgetsService.updateWidgetStatus({
                query: { activate },
                path: { widget: 'generic' },
            });

            if (!response.data) throw new Error('Failed');

            return response.data;
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
            queryClient.setQueryData(WIDGET_ACTIVATED_QUERY_KEY, {
                activated: variables.activate,
            });
        },
        ...options,
    });
};
